import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FnI18nService, FnMenuDataService, FnToasterService, hwObject} from 'foundation';
import { Observable, Subject } from 'rxjs';
import { MenuRedirectService } from '../services/menu.redirection.service';
import { LandingService } from './landing.service';
import { PosAppService } from '../services/pos.app.service';
import { PosLoginResponseService } from '../services/pos.login.response.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {
  
  menuItemArray :string []=[];
  // url to get menu Data 
  private _jsonURL = 'assets/menuData.json';
  isLoading = false;
  // varible to store active menu data 
  activeMenu: any;
  // varible to show menu side bar if data loaded sucessfully.
  isMenuLoaded = false;
  // ajax to load menu Data 
  getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }
  // class contructor to load services reference
  constructor(private http: HttpClient,
    private menuDataSvcs: FnMenuDataService,
    private fn18nService: FnI18nService,
    private menuRedirectService: MenuRedirectService,
    private landingService : LandingService,
    private posAppService : PosAppService,
    private loginResponse : PosLoginResponseService,
    private router: Router,
    private toaster: FnToasterService
  ) { }
  

  ngOnInit(): void {
    //  let s = window.location+'';
    // let s1 = (s.substring(0,s.indexOf('#')));   
    // environment.API_LOCAL_URL =s1+'v1';
    const token = this.loginResponse.authToken;
    if (token) {
       this.getMenuJSON();
    } else {
      this.posAppService.setAuthToken(this.posAppService.getAppSession());
      this.getMenuJSON();
    }
  }

  getMenuJSON() {
    this.landingService.getMenuJson().subscribe(data => {
      const menuItemArray = data.menuDataHash.menuData.menuItemArray;
      this.menuItemArray = this.filterMenuItemArray(menuItemArray);
      this.fn18nService.loadTranslateMessage('en', data.labelHash);
      this.fn18nService.setLanguage('en');
      this.menuDataSvcs.loadMenuData(data.menuDataHash.menuData).subscribe(menuLoaded => {
        this.menuDataSvcs.getActiveMenuId$().subscribe(menuId => {
          this.activeMenu = this.menuDataSvcs.getMenuItemById(menuId);
          this.isMenuLoaded = menuLoaded;
          this.isLoading = true;
        });
      });
    });
  }
  
  filterMenuItemArray(menuItemArray: any[]): any[] {
    let filterArray: any[] = [];
    menuItemArray.forEach(item => {
      filterArray.push(item); 
      if (item.menuItemArray && Array.isArray(item.menuItemArray)) {
        filterArray = filterArray.concat(this.filterMenuItemArray(item.menuItemArray));
      }
    });
    return filterArray;
  }

  onClickMenu(menuId: string) {
    // this.data.name="123";
    this.menuRedirectService.redirectToUrlWithMenuId(menuId);
  }
}
